import { useStore } from "@tanstack/react-form";

import { isEmptyAccessioningNotesHtml } from "@blis/shared/schemas/accessioning-notes";
import { trpc } from "@blis/trpc/react";

import { Note } from "@/components/ui/note";
import { sanitizeHtml } from "@/features/admin/utils/html";
import { useAuth } from "@/features/auth/hooks";
import { useAccessionForm } from "./AccessionFormProvider";

export function AccessioningNotes() {
  const { form } = useAccessionForm();
  const orgId = useStore(form.store, (s) => s.values.orgId);
  return <AccessioningNotesForOrg orgId={orgId} />;
}

export function AccessioningNotesForOrg({
  orgId,
}: {
  orgId: number | null | undefined;
}) {
  const { user } = useAuth();
  const { data: primaryOrgs } = trpc.orgs.primaryOrgsList.useQuery(undefined, {
    enabled: !!user?.isLabRole(),
  });

  const notes =
    typeof orgId === "number" && !Number.isNaN(orgId) && orgId > 0
      ? primaryOrgs?.find((org) => org.id === orgId)?.accessioningNotes
      : null;

  if (!user?.isLabRole() || isEmptyAccessioningNotesHtml(notes)) {
    return null;
  }

  const html = sanitizeHtml(notes ?? "");

  return (
    <Note intent="info" className="my-0 w-full shrink-0">
      <span className="font-medium">Accessioning notes</span>
      <div
        className="mt-1.5 text-sm [&_a]:underline [&_ul]:list-disc [&_ul]:pl-4 [&_ol]:list-decimal [&_ol]:pl-4"
        // Sanitized with sanitizeHtml before render.
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </Note>
  );
}
